import { render, staticRenderFns } from "./QueuesFilter.vue?vue&type=template&id=2f8fc261&"
import script from "./QueuesFilter.vue?vue&type=script&lang=ts&"
export * from "./QueuesFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports